import Endpoints from '../endpoints';
import { axiosInstance } from '../instance';

const handleError = (e, fallback) => {
  console.log(e);
  const data = e.response?.data;
  const detail = data?.error || data?.detail;
  if (typeof detail === 'string') return { error: detail };
  if (Array.isArray(detail)) return { error: detail.map((x) => x.msg || x).join('; ') };
  return { error: fallback };
};

export const getStats = async () => {
  try {
    const res = await axiosInstance.get(Endpoints.CHARACTERISTICS.STATS);
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось получить статистику');
  }
};

export const getCategorySummary = async (categoryId) => {
  try {
    const res = await axiosInstance.get(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/summary',
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось загрузить сводку категории');
  }
};

export const getCategoryRawFields = async (categoryId, params) => {
  try {
    const res = await axiosInstance.get(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/raw-fields',
      { params },
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось загрузить поля');
  }
};

export const getCategoryExceptions = async (categoryId, params) => {
  try {
    const res = await axiosInstance.get(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/exceptions',
      { params },
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось загрузить проблемы');
  }
};

export const unmapField = async (categoryId, body) => {
  try {
    const res = await axiosInstance.post(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/unmap-field',
      body,
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось отменить привязку');
  }
};

export const publishField = async (categoryId, body) => {
  try {
    const res = await axiosInstance.post(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/publish-field',
      body,
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось настроить поле');
  }
};

export const saveFieldMapping = async (categoryId, body) => {
  try {
    const res = await axiosInstance.post(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/field-mapping',
      body,
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось сохранить');
  }
};

export const autoApplySuggestions = async (categoryId) => {
  try {
    const res = await axiosInstance.post(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/auto-apply',
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось применить автоматически');
  }
};

export const llmAutoMap = async (categoryId, params = {}) => {
  try {
    const res = await axiosInstance.post(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/llm-auto-map',
      null,
      { params: { async_mode: true, ...params }, timeout: 180000 },
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось автонастроить через AI');
  }
};

export const getLlmAutoMapStatus = async (categoryId, params = {}) => {
  try {
    const res = await axiosInstance.get(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/llm-auto-map/status',
      { params },
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось получить статус AI');
  }
};

export const getCategoryProperties = async (categoryId) => {
  try {
    const res = await axiosInstance.get(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/properties',
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось загрузить свойства');
  }
};

export const getCategoryValues = async (categoryId, params = {}) => {
  try {
    const res = await axiosInstance.get(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/values',
      { params, timeout: 120000 },
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось загрузить значения');
  }
};

export const recomputeCategory = async (categoryId, force = false) => {
  try {
    const res = await axiosInstance.post(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/recompute',
      null,
      { params: { force, async_mode: true }, timeout: 60000 },
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось обновить товары');
  }
};

export const getRecomputeStatus = async (categoryId, params = {}) => {
  try {
    const res = await axiosInstance.get(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/recompute/status',
      { params },
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось получить статус применения');
  }
};

export const exportCategoryToBitrix = async (categoryId, params = {}) => {
  try {
    const res = await axiosInstance.post(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/export-bitrix',
      null,
      { params, timeout: 180000 },
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось запустить выгрузку в Bitrix');
  }
};

export const getExportBitrixStatus = async (categoryId, params = {}) => {
  try {
    const res = await axiosInstance.get(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/export-bitrix/status',
      { params },
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось получить статус выгрузки');
  }
};

export const patchDefinition = async (definitionId, body) => {
  try {
    const res = await axiosInstance.patch(
      Endpoints.CHARACTERISTICS.DEFINITIONS + '/' + definitionId,
      body,
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось сохранить настройку свойства');
  }
};

export const resetCategory = async (categoryId) => {
  try {
    const res = await axiosInstance.post(
      Endpoints.CHARACTERISTICS.CATEGORY + categoryId + '/reset',
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось сбросить настройки категории');
  }
};

export const getDefinitions = async (params) => {
  try {
    const res = await axiosInstance.get(Endpoints.CHARACTERISTICS.DEFINITIONS, { params });
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось загрузить атрибуты');
  }
};

export const getProduct = async (goodId) => {
  try {
    const res = await axiosInstance.get(Endpoints.CHARACTERISTICS.PRODUCT + goodId);
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось загрузить карточку');
  }
};

export const recomputeProduct = async (goodId, force = false) => {
  try {
    const res = await axiosInstance.post(
      Endpoints.CHARACTERISTICS.PRODUCT + goodId + '/recompute',
      null,
      { params: { force } },
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось пересчитать');
  }
};

export const approveItem = async (goodId, code) => {
  try {
    const res = await axiosInstance.post(
      Endpoints.CHARACTERISTICS.PRODUCT + goodId + '/items/' + code + '/approve',
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось подтвердить');
  }
};

export const rejectItem = async (goodId, code) => {
  try {
    const res = await axiosInstance.post(
      Endpoints.CHARACTERISTICS.PRODUCT + goodId + '/items/' + code + '/reject',
    );
    return res.data;
  } catch (e) {
    return handleError(e, 'Не удалось отклонить');
  }
};

const characteristics = {
  getStats,
  getCategorySummary,
  getCategoryRawFields,
  getCategoryProperties,
  getCategoryValues,
  getCategoryExceptions,
  publishField,
  unmapField,
  saveFieldMapping,
  autoApplySuggestions,
  llmAutoMap,
  getLlmAutoMapStatus,
  recomputeCategory,
  getRecomputeStatus,
  resetCategory,
  exportCategoryToBitrix,
  getExportBitrixStatus,
  patchDefinition,
  getDefinitions,
  getProduct,
  recomputeProduct,
  approveItem,
  rejectItem,
};

export default characteristics;
